var _rect, _rect2, _path, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _circle4, _path3, _path4, _path5, _path6, _circle5, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 155,
    viewBox: "0 0 183 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.646,
    y: 101.684,
    width: 19.873,
    height: 15.292,
    rx: 7.646,
    transform: "rotate(-30 7.646 101.684)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 12.715,
    width: 15.309,
    height: 15.309,
    rx: 7.654,
    transform: "rotate(-30 131.16 12.715)",
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.93 68.277a7.654 7.654 0 107.655 13.257l4.323-2.496a8.48 8.48 0 01.114-.067l26.164-15.106a7.654 7.654 0 017.654 13.258L61.74 88.15l.048-.027 61.81-35.686.086-.05-1.226.708a7.654 7.654 0 01-10.456-2.802 7.654 7.654 0 012.801-10.456l5.754-3.322a7.654 7.654 0 00-7.789-13.178L34.93 68.277zm52.652 40.308a7.654 7.654 0 007.654 13.258l55.803-32.218a7.654 7.654 0 002.801-10.456 7.653 7.653 0 00-10.455-2.801l-55.803 32.217zm29.801-34.882l-.442.255c.075-.042.149-.082.225-.12a7.653 7.653 0 00-2.498 10.27 7.654 7.654 0 0010.143 2.973c-.099.063-.2.125-.303.184l-47.411 27.373-.071.041 10.344-5.972a7.655 7.655 0 00-7.655-13.258l-23.994 13.853a7.654 7.654 0 01-7.542-13.321l94.296-54.442a7.654 7.654 0 117.654 13.258l-6.409 3.7a9.606 9.606 0 00-.087.05l-26.164 15.105a4.334 4.334 0 00-.086.051z",
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.39,
    cy: 108.685,
    r: 3.971,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.287,
    cy: 44.482,
    r: 2.952,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.444,
    cy: 134.55,
    r: 4.527,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.508,
    y: 3.906,
    width: 9.515,
    height: 1.699,
    rx: 0.85,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.115,
    width: 9.515,
    height: 1.699,
    rx: 0.85,
    transform: "rotate(90 114.115 0)",
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.719,
    y: 133.289,
    width: 7.136,
    height: 1.699,
    rx: 0.85,
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144.137,
    y: 130.656,
    width: 7.136,
    height: 1.699,
    rx: 0.85,
    transform: "rotate(90 144.137 130.656)",
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.52,
    y: 83.813,
    width: 7.136,
    height: 1.699,
    rx: 0.85,
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.938,
    y: 81.18,
    width: 7.136,
    height: 1.699,
    rx: 0.85,
    transform: "rotate(90 13.938 81.18)",
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 74,
    width: 110,
    height: 33,
    rx: 12.185,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.656 45.168A12.185 12.185 0 0165.462 36h51.076a12.185 12.185 0 0111.806 9.168L135.712 74H46.288l7.368-28.832z",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 91,
    r: 7,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h43c6.075 0 11 4.925 11 11v9c0 6.075-4.925 11-11 11H91V75z",
    fill: "#ECECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107h18v12.407A5.593 5.593 0 0160.407 125h-6.814A5.593 5.593 0 0148 119.407V107z",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116 107h18v12.407a5.593 5.593 0 01-5.593 5.593h-6.814a5.593 5.593 0 01-5.593-5.593V107z",
    fill: "#ECECEC",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h74",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 91,
    r: 7,
    fill: "#ECECEC",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h36.5l7 27H91V46zM91 37h26.067c4.457 0 8.434 2.802 9.933 7H91v-7z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCars);
export default __webpack_public_path__ + "static/media/cars.ee1c2a0c.svg";
export { ForwardRef as ReactComponent };